import { render, staticRenderFns } from "./SaleReport.vue?vue&type=template&id=5c9f64a4&scoped=true"
import script from "./SaleReport.vue?vue&type=script&lang=ts"
export * from "./SaleReport.vue?vue&type=script&lang=ts"
import style0 from "./SaleReport.vue?vue&type=style&index=0&id=5c9f64a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f64a4",
  null
  
)

export default component.exports